import { differenceInCalendarDays, startOfDay } from "date-fns";
import formatDateStringToObject from "syf-js-utilities/formats/formatDateStringToObject";
import offsetDateToEst from "syf-js-utilities/formats/offsetDateToEst";
var calcDaysLeft = function (dayString, endDate) {
    if (!endDate) {
        return undefined;
    }
    var today = offsetDateToEst(startOfDay(new Date()));
    var dateToCompare = offsetDateToEst(startOfDay(formatDateStringToObject(endDate)));
    if (dateToCompare > today) {
        var remainingDays = differenceInCalendarDays(dateToCompare, today);
        return "".concat(remainingDays, " ").concat(dayString);
    }
    return undefined;
};
export default calcDaysLeft;
//# sourceMappingURL=calcDaysLeft.js.map